import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative flex h-2 w-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'LeadStatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const statusClasses = {
  activeSubscriber: 'bg-emerald-500 text-emerald-50 bg-emerald-500/10',
  inactiveSubscriber: 'bg-red-400 text-red-50 bg-red-400/10',
  nonSubscriber: 'bg-zinc-500 text-zinc-50 bg-zinc-500/10',
}
const statusLabels = {
  activeSubscriber: 'Assinante ativo',
  inactiveSubscriber: 'Assinante inativo',
  nonSubscriber: 'Não assinante',
}


return (_ctx: any,_cache: any) => {
  return (statusClasses[_ctx.status as keyof typeof statusClasses])
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([
      'inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs font-medium',
      statusClasses[_ctx.status as keyof typeof statusClasses],
  ])
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass([
              'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
              statusClasses[_ctx.status as keyof typeof statusClasses].split(' ')[0],
          ])
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass([
              'relative inline-flex h-2 w-2 rounded-full',
              statusClasses[_ctx.status as keyof typeof statusClasses].split(' ')[0],
          ])
          }, null, 2)
        ]),
        _createTextVNode(" " + _toDisplayString(statusLabels[_ctx.status as keyof typeof statusLabels]), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})